import React from 'react';
import { TopMenu } from '../TopMenu';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store';
import { Text } from '@fluentui/react';

interface CRMWebResourceLayoutProps {
    children: any;
}

const CRMWebResourceLayout: React.FC<CRMWebResourceLayoutProps> = ({ children }) => {
    const state = useSelector((state: RootState) => state.status);

    return (
        <div style={{ margin: '16px', marginTop: '8px', display: 'inline-block', }}>
            {!state.webResourceEmbedded &&
                <div style={{ width: '100%', marginBottom: '15px' }}>
                    <TopMenu styles={{ root: { borderRadius: '8px' } }} />
                </div>
            }

            {children}
            <Text
                variant='xSmall'
                styles={{
                    root: {
                        color: 'gray',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        display: 'block',
                        textAlign: 'center',
                        marginTop: '6px'
                    }
                }}
            >
                Version {process.env.REACT_APP_VERSION} / CRM {process.env.REACT_APP_CRM} / PORTAL {process.env.REACT_APP_PORTAL}
            </Text>
        </div>
    );
};

export default CRMWebResourceLayout;



